import { PROFILE_CHANGE_PASSWORD_GQL, PROFILE_UPDATE_GQL } from './gql';
import { apolloClient } from '../client';
import { ProfileInput } from './profile.types';
import { MutationUpdateProfileArgs } from '../types.generated';

export const profileUpdateMutation = async (payload: ProfileInput): Promise<MutationUpdateProfileArgs | undefined> => {
  const { id, email, locale } = payload;

  const response = await apolloClient.mutate<{ updateProfile }>({
    mutation: PROFILE_UPDATE_GQL,
    variables: {
      id,
      input: { email, locale },
    },
  });

  return response.data?.updateProfile;
};

export const changePasswordMutation = async (id: string, password: string): Promise<MutationUpdateProfileArgs | undefined> => {
  const response = await apolloClient.mutate<{ changePassword }>({
    mutation: PROFILE_CHANGE_PASSWORD_GQL,
    variables: {
      id,
      password,
    },
  });

  return response.data?.changePassword;
};
